import React                      from 'react';
import PropTypes                  from 'prop-types';
import SocialShareBarShareContent from './../SocialShareBar/SocialShareBarShareContent';
import Translations               from './../../utils/Translations';

class PostShare extends React.Component {
	render() {
		return (
			<div className="row magazine-blog-post--single__share-wrapper">
				<div className="col-md-10 col-md-offset-1 col-sm-12 col-xs-12">
					<h4 className="magazine-blog-post--single__share--title">
						<i className="icon -icon-share-icon" />
						{Translations.get('MagazinePostShare')}
					</h4>
					<SocialShareBarShareContent title={this.props.title}
					                            mediaId={this.props.id}
					                            gaPrefix={'blog'}
					                            url={this.props.url}
					                            isSeekableMedia={false}
					/>
				</div>
			</div>
		);
	}
}

PostShare.propTypes = {
	url:   PropTypes.string.required,
	id:    PropTypes.string.required,
	title: PropTypes.string.required,
};

export default PostShare;
